// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { WishListLineModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import MyListsDetailsBunzlProductListLine from "@store/Library/Widgets/MyListDetails/MyListsDetailsBunzlProductListLine";
import { OwnProps } from "@store/Overrides/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import React from "react";
import { SortableContainer, SortableElement, SortEvent } from "react-sortable-hoc";

interface BuyingListLineItemProps extends OwnProps {
    gridItemProps: GridItemProps | undefined;
    updateSortOrder: (wishListLine: WishListLineModel, value: number | string) => void;
    showSpecificationModal: boolean;
}

interface BuyingListProductListSortableProps extends Omit<BuyingListLineItemProps, "productInfo" | "wishListLine"> {
    productInfosByWishListLineId: SafeDictionary<ProductInfo>;
    wishListLines: WishListLineModel[];
}

export const BuyingListLineItem = SortableElement<BuyingListLineItemProps>((props: BuyingListLineItemProps) => {
    const { gridItemProps, ...rest } = props;
    return (
        <GridItem
            key={props.wishListLine.id}
            {...gridItemProps}
            data-test-selector={`buyingListSortable_lineItem_${props.wishListLine.id}`}
        >
            <MyListsDetailsBunzlProductListLine {...rest} />
        </GridItem>
    );
});

export const BuyingListProductListSortable = SortableContainer<BuyingListProductListSortableProps>(
    (props: BuyingListProductListSortableProps) => {
        const { productInfosByWishListLineId, wishListLines, ...rest } = props;
        return (
            <StyledWrapper data-test-selector="buyingListSortable_container">
                {wishListLines.map((wishListLine, index) => {
                    const productInfo = productInfosByWishListLineId[wishListLine.id];
                    if (!productInfo) {
                        return null;
                    }
                    return (
                        <BuyingListLineItem
                            key={wishListLine.id}
                            wishListLine={wishListLine}
                            index={index}
                            productInfo={productInfo}
                            {...rest}
                        />
                    );
                })}
            </StyledWrapper>
        );
    },
);

export const useBuyingListProductListSortable = (
    wishList: WishListModel | undefined,
    updateBuyingListLine: (wishListLine: WishListLineModel) => void,
) => {
    if (!wishList || typeof window === "undefined") {
        return {
            updateSortOrder: (wishListLine: WishListLineModel, value: number | string) => {},
            onSortMove: (e: SortEvent) => {},
        };
    }
    const updateSortOrder = (wishListLine: WishListLineModel, value: number | string) => {
        const sortOrder = parseInt(value.toString() || "1", 10);
        if (wishListLine.sortOrder === sortOrder) {
            return;
        }
        const wishListLineToUpdate = { ...wishListLine, sortOrder };

        updateBuyingListLine(wishListLineToUpdate);
    };
    const scroll = (step: number) => {
        window.scrollBy(0, step);
    };

    const onSortMove = (e: SortEvent) => {
        e.preventDefault();

        let clientY = 0;
        if ((e as any).clientY !== undefined) {
            clientY = (e as any).clientY;
        } else if ((e as any).targetTouches !== undefined) {
            clientY = (e as any).targetTouches[0].clientY;
        } else {
            return;
        }

        if (clientY < 50) {
            scroll(-20);
        } else if (clientY < 100) {
            scroll(-10);
        }

        const bottom = window.innerHeight - clientY;
        if (bottom < 50) {
            scroll(20);
        } else if (bottom < 100) {
            scroll(10);
        }
    };
    return { updateSortOrder, onSortMove };
};
